<template>
    <router-view></router-view>
</template>

<script>
import SettingsStore from 'stores/settings/settingsStore';
export default {
    created() {
        this.$store.registerModule('settingsStore', SettingsStore);
    },
    beforeDestroy() {
        this.$store.unregisterModule('settingsStore');
    },
};
</script>
